"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0; // Returns false for falsey values & whitespace, true otherwise.

var isFilledIn = function isFilledIn(value) {
  if (!value) return false;
  if (value.toString().match(/^\s*$/)) return false;
  return true;
};

var _default = isFilledIn;
exports.default = _default;